// The console is always cross-origin to core. Base URL: env var → localhost
// fallback (dev) → same-origin (deployed, non-localhost). No /v2 case.
const FALLBACK_BASE_URL = 'http://localhost:8001';

export function resolveBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_BIOWEAVE_API_BASE_URL;
  if (typeof fromEnv === 'string' && fromEnv.length > 0) return fromEnv.replace(/\/$/, '');
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return FALLBACK_BASE_URL;
    return '';
  }
  return FALLBACK_BASE_URL;
}

export function resolveModerationBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_BIOWEAVE_MODERATION_BASE_URL;
  if (typeof fromEnv === 'string' && fromEnv.length > 0) return fromEnv.replace(/\/$/, '');
  return 'http://localhost:8090';
}
